/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const MESSAGES = {
  DESCRIPTION_INFO: "Description of the application.",
  APPLICATION_NAME_INFO: "Name of the application to be configured with LIAM.",
  APPLICATION_NAME_REQUIRED: "Application name is required.",
  DESCRIPTION_REQUIRED: "Description is required.",
  CONTACT_EMAIL_INFO: `Only Jdadelivers,jda or blueyonder Email addresses are accepted in this field, such as 1011010@jdadelivers.com.`,
  APP_ACCOUNT_KEY_INFO: `Account key is a unique identifier for the module and can't be changed later. Account Key should contain only lowercase alphabets (a-z). Max length is 8 characters.`,
  APP_ACCOUNT_KEY_REGEX: /^[a-z]+$/,
  APP_ACCOUNT_KEY_ALLOWED_CHARACTERS: "Account key should contain only lowercase alphabets (a-z). Max length is 8 characters.",
  MAX_APP_ACCOUNT_KEY_LENGTH: "Account Key cannot exceed 8 characters.",
  APP_ACCOUNT_KEY_REQUIRED: "Application Account Key is required and should contain only lowercase alphabets (a-z)",
  CONTACT_EMAIL_REQUIRED: "Contact email is required.",
  CONTACT_EMAIL_INVALID: "Contact email is invalid. It should be a valid Jdadelivers, jda, or blueyonder email address.",
  CONTACT_EMAIL_REGEX_VALIDATION: /^[A-Za-z0-9._%+-]+@(jdadelivers|jda|blueyonder)\.com$/,
};

export const TITLE = {
  SAVE: "Save",
  CANCEL: "Cancel",
  DESCRIPTION: "Description",
  CONTACT_EMAIL: "Contact Email",
  ADD_APPLICATION: "Add Application",
  EDIT_APPLICATION: "Edit Application",
  ORGANIZATION_NAME: "Organization Name",
  APPLICATION_NAME: "Application Name",
  APP_ACCOUNT_KEY: "Application Account Key",
  ADD_APPLICATION_DIALOG: "AddApplicationDialog"
};
